// tslint:disable:max-line-length
import * as React from 'react';

export const featureMvk = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="#FFF" fillRule="nonzero" transform="translate(1 1)">
      <rect width="1" height="3" x="1" stroke="#FFF" strokeWidth=".8" rx=".5" transform="rotate(-45 1.5 1.5)"/>
      <rect width="1" height="3" x="14" stroke="#FFF" strokeWidth=".8" rx=".5" transform="scale(-1 1) rotate(-45 0 36.506)"/>
      <rect width="1" height="3" x="1" y="13" stroke="#FFF" strokeWidth=".8" rx=".5" transform="scale(1 -1) rotate(-45 -33.506 0)"/>
      <rect width="1" height="3" x="14" y="13" stroke="#FFF" strokeWidth=".8" rx=".5" transform="rotate(135 14.5 14.5)"/>
      <rect width="8" height="8" x="4" y="4" rx="1"/>
    </g>
  </svg>
);
// tslint:enable:max-line-length
